import {
  FETCHING_ASSETS_COUNT,
  FETCHING_ASSETS_COUNT_SUCCEEDED,
  FETCHING_ASSETS_COUNT_FAILED,
  FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE,
  FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_SUCCEEDED,
  FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_FAILED,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED,
  FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { error } from "jquery";

const API_URL = process.env.REACT_APP_API_URL;
const ASSETS_BASE_URL = `${API_URL}/api/1.0/assets`;
const ASSETS_EMAIL_PROCESSING_BASE_URL =`${API_URL}/api/1.0/assets`


/** fetch assets */
export const fetchAssetsCount = createAction(FETCHING_ASSETS_COUNT);
const fetchingAssetsCountSucceeded = createAction(FETCHING_ASSETS_COUNT_SUCCEEDED);
const fetchingAssetsCountFailed = createAction(FETCHING_ASSETS_COUNT_FAILED);

function* fetchAssetsCountSaga(action) {
  let { account } = action.payload;

  let url = buildUrl(ASSETS_BASE_URL, { path: "/count" });
  const fetchAssetsCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account: account },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetsCountAPI);
    yield put(fetchingAssetsCountSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetsCountFailed(error));
  }
}


export const fetchAssetProcessingEmailContent = createAction(FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE, (emails, template_type, message) => {
  return {
    emails: emails,
    type: template_type,
    message: message
  }
});
const fetchAssetProcessingEmailContentSucceeded = createAction(FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_SUCCEEDED,(response)=>{
  return{
    response: response
  }
});
const fetchAssetProcessingEmailContentFailed = createAction(FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE_FAILED,(error)=>{
  return{
    error: error
  }
} );

function* fetchAssetProcessingEmailContentSaga(action) {
  let { emails, type, message } = action.payload;

  let url = buildUrl(ASSETS_EMAIL_PROCESSING_BASE_URL, { path: "/asset-processing-alert" });

  const body = {
    toEmailList: emails,
    type: type,
    message: message,
  };

  const fetchAssetProcessingEmailAPI = (body) =>
    axios({
      method: "POST",
      url: url,
      data: body, 
    }).then((response) => response.data);

  try {
    const response = yield call(fetchAssetProcessingEmailAPI, body);
    yield put(fetchAssetProcessingEmailContentSucceeded(response));
  } catch (error) {
    yield put(fetchAssetProcessingEmailContentFailed(error));
  }
}


export const fetchAdminUsers = createAction(FETCHING_ADMIN_USERS_FOR_ACCOUNT, (query,accountId) => {
  return {
    query: query,
    account: accountId
  }
});

const fetchAdminUsersSucceeded = createAction(FETCHING_ADMIN_USERS_FOR_ACCOUNT_SUCCEEDED,(response)=>{
  return{
    response: response
  }
});
const fetchAdminUsersFailed = createAction(FETCHING_ADMIN_USERS_FOR_ACCOUNT_FAILED,(error)=>{
  return{
    error: error
  }
} );

function* fetchAssetProcessingAdminUserSaga(action) {
  let { query, account } = action.payload;
  let url = buildUrl(ASSETS_EMAIL_PROCESSING_BASE_URL, {
    queryParams:{
       query: query,
       account: account
    }
  });

  const fetchAssetProcessingAdminUserAPI = () =>
    axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);

  try {

   const response = yield call(fetchAssetProcessingAdminUserAPI);
    yield put(fetchAdminUsersSucceeded(response));
  } catch (error) {
   yield put(fetchAdminUsersFailed(error));
  }
}




export default function* assetsSaga() {
  yield takeLatest(FETCHING_ASSETS_COUNT, fetchAssetsCountSaga);
  yield takeLatest(FETCH_ASSET_PROCESSING_EMAIL_TEMPLATE, fetchAssetProcessingEmailContentSaga)
  yield takeLatest(FETCHING_ADMIN_USERS_FOR_ACCOUNT,fetchAssetProcessingAdminUserSaga)
}
